import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_mof_doc_hdr_RowClass,
} from '../../../dbschema';

export class MofDocHdrContainerModel extends BaseContainerModel {
  bl_aat_mof_doc_hdr: bl_aat_mof_doc_hdr_RowClass = new bl_aat_mof_doc_hdr_RowClass();
}
